import GoCart from './go_cart';

export default GoCart;
